/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Nav_PaymentsInputs */

const en_settings_nav_payments = /** @type {(inputs: Settings_Nav_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments`)
};

const zh_settings_nav_payments = /** @type {(inputs: Settings_Nav_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付款记录`)
};

/**
* | output |
* | --- |
* | "Payments" |
*
* @param {Settings_Nav_PaymentsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_nav_payments = /** @type {((inputs?: Settings_Nav_PaymentsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Nav_PaymentsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_nav_payments(inputs)
	return zh_settings_nav_payments(inputs)
});
export { settings_nav_payments as "settings.nav.payments" }